import { useState } from 'react';
import '../../App.css';
import './ProdutosPage.css';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';

import Produtos from '../../assets/fotos/produtos.jpg';

export default function ProdutosPage(){

  return (
    <div className="ProdutosPage-container">
        <Header/>
       
        <article>
          <div className="Produtos">
            <div className="Produtos-texto">
            A utilização de produtos de qualidade é essencial para garantir resultados eficazes e duradouros. 
            Seja em tratamentos de beleza, cuidados com a pele ou manutenção estética, escolher os melhores produtos 
            pode fazer toda a diferença. Produtos de alta qualidade são formulados com ingredientes selecionados e 
            com rigoroso controle, o que proporciona segurança e confiança no uso. Além disso, esses produtos são
            desenvolvidos para atender às necessidades específicas de cada pessoa, respeitando diferentes tipos de 
            pele e condições. Ao optar por cosméticos e materiais de qualidade, você assegura não apenas a eficácia 
            do tratamento, mas também a proteção contra possíveis irritações ou danos. No nosso espaço, oferecemos 
            uma seleção cuidadosa desses produtos para proporcionar a você uma experiência única. Pensando nisso, 
            também disponibilizamos produtos para venda, para que você possa continuar os cuidados em casa com a 
            mesma excelência encontrada em nossos serviços.
            </div>
            <div className="Produtos-fotos">
                <img src={Produtos} alt="Produtos" className="Produtos-img-produto"/>
            </div>
          </div>
        </article>

        <Footer />
    </div>
  );  
}